export const environment = {
  production: true,
  // apiUrl: '/api/',
  apiUrl: 'https://api.card4games.com/v1/',
  admin_email: 'admin@admin.com',
};
